module.exports = __webpack_public_path__ + "hair-on-fire.9b608c.svg";